import React, { useEffect, useRef } from 'react';
import './Features.css';

const Features = () => {
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const cards = gridRef.current?.querySelectorAll('.feature-card');
    cards?.forEach((c) => observer.observe(c));
    return () => cards?.forEach((c) => observer.unobserve(c));
  }, []);

  const features = [
    { icon: '🏛\uFE0F', title: 'Modern Infrastructure', description: 'State-of-the-art classrooms, laboratories, and sports facilities for comprehensive learning.' },
    { icon: '💻', title: 'Smart Classrooms', description: 'Technology-enabled learning spaces with interactive boards and digital resources.' },
    { icon: '📚', title: 'Rich Library', description: 'Extensive collection of books, journals, and digital resources for research and reading.' },
    { icon: '🔬', title: 'Advanced Labs', description: 'Well-equipped science, computer, and language laboratories for practical learning.' },
    { icon: '\u26BD', title: 'Sports Complex', description: 'Multi-purpose sports facilities including playgrounds, courts, and indoor sports areas.' },
    { icon: '🚌', title: 'Safe Transport', description: 'GPS-enabled buses with trained drivers ensuring safe commute for students.' },
    { icon: '🍽\uFE0F', title: 'Healthy Cafeteria', description: 'Nutritious meals prepared in hygienic environment with diverse menu options.' },
    { icon: '🎭', title: 'Arts & Culture', description: 'Music rooms, art studios, and auditorium for nurturing creative talents.' },
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-title">
          <h2>Why Choose MTC School?</h2>
          <p>Discover the facilities and features that make us the preferred choice for quality education</p>
        </div>
        <div className="features-grid" ref={gridRef}>
          {features.map((feature, index) => (
            <div className="feature-card" key={index} style={{ transitionDelay: `${index * 0.08}s` }}>
              <div className="feature-icon-wrapper">
                <span className="feature-icon">{feature.icon}</span>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="features-cta">
          <div className="cta-content">
            <h3>Ready to Join Our Family?</h3>
            <p>Take the first step towards your child's bright future. Schedule a campus visit today!</p>
          </div>
          <a href="#enroll" className="btn btn-gold">Schedule a Visit</a>
        </div>
      </div>
    </section>
  );
};

export default Features;
